import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconArrowRight: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M8.578 16.594l4.594-4.594-4.594-4.594 1.406-1.406 6 6-6 6z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconArrowRight;
